export default __webpack_public_path__ + "static/media/logo.a7b59bc6.svg";